module.exports = __webpack_public_path__ + "img/ltkshoecrush-4x.0632ce4.jpg";